import type { PositionResponse } from "./types";

export async function pollPosition(
  endpoint: string,
  ref: string,
  signal?: AbortSignal,
): Promise<PositionResponse> {
  const res = await fetch(endpoint, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ ref }),
    cache: "no-store",
    signal,
  });

  if (!res.ok) {
    if (res.status === 404) return { ok: false, reason: "not_found" };
    if (res.status === 401 || res.status === 403)
      return { ok: false, reason: "invalid_signature" };
    if (res.status === 410) return { ok: false, reason: "expired" };
    return { ok: false, reason: "unknown" };
  }

  return (await res.json()) as PositionResponse;
}
